/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantDetails {
    getFixupPrototypeFunction() { return TenantDetails.fixupPrototype; }

    static newInstance(model: Partial<TenantDetails>): TenantDetails {
        let obj = Object.assign(new TenantDetails(), model);
        TenantDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantDetails>): TenantDetails {
        if (!model) return null;
        return TenantDetails.newInstance(<TenantDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantDetails) {
        if (!obj) return;

        models.TenantDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantDetails): boolean {
        Object.setPrototypeOf(obj, TenantDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.fiscal_year_configuration) {
            models.FiscalYearConfiguration.fixupPrototype(this.fiscal_year_configuration);
        }
        if (this.cost_anomaly_settings) {
            models.CostAnomalyConfiguration.fixupPrototype(this.cost_anomaly_settings);
        }
        if (this.cost_processing_settings) {
            models.CostProcessingSettings.fixupPrototype(this.cost_processing_settings);
        }
        if (this.disk_utilization_settings) {
            models.DiskUtilizationSetting.fixupPrototype(this.disk_utilization_settings);
        }
        if (this.activity_queue_notifications) {
            models.ActivityQueueNotificationDetails.fixupPrototype(this.activity_queue_notifications);
        }
        if (this.email_notify) {
            models.EmailNotifyConfiguration.fixupPrototype(this.email_notify);
        }
        if (this.configuration_management) {
            models.TenantConfigurationManagementOptions.fixupPrototype(this.configuration_management);
        }
        if (this.dimension_settings) {
            for (let val of this.dimension_settings) {
                models.DimensionTenantSettings.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the tenant. This will be used for performing tenant level operations such as createPolicy, createScript, onboardCloudAccount and so on.
     */
    tenant_id: string;

    /**
     * Unique name of the tenant provided as input while creating.
     */
    name: string;

    /**
     * Description of the tenant.
     */
    description: string;

    /**
     * Id of the CoreStack account under which this tenant resides.
     */
    account_id: string;

    /**
     * Is the master tenant
     */
    is_default: boolean;

    /**
     * Fiscal Year settings
     */
    fiscal_year_configuration: models.FiscalYearConfiguration;

    cost_anomaly_settings: models.CostAnomalyConfiguration;

    cost_processing_settings: models.CostProcessingSettings;

    /**
     * azure hybrid benefits enabled under finOps
     */
    azure_hybrid_benefits_enabled: boolean;

    /**
     * enables disk utilization configuration for specified service accounts
     */
    disk_utilization_settings: models.DiskUtilizationSetting;

    dimension_settings: Array<models.DimensionTenantSettings>;

    /**
     * Indicates the status of the Tenant
     */
    status: models.TenantStatus;

    /**
     * Created DateTime in UTC of the tenant.
     */
    created_at: string;

    activity_queue_notifications: models.ActivityQueueNotificationDetails;

    /**
     * Email notification configuration
     */
    email_notify: models.EmailNotifyConfiguration;

    configuration_management: models.TenantConfigurationManagementOptions;

}
